import styled from 'styled-components';
import { CaptionRegularM, DefaultInput, IDefaultInput } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';
import { ArrowCont, InfoStaticIconCont } from '../SearchDropdown.styles';
import ErrorIcon from '@/assets/icons/errorMsgIcon.svg?react';

export const ErrorIconCont = styled.div`
  position: absolute;
  top: 11px;
  right: 38px;
`;

interface IDropSearchInput {
  width?: string;
  height?: string;
}

export const DropSearchInput = styled(DefaultInput)<IDropSearchInput>`
  border-width: 2px;
  ${({ width, height }: IDropSearchInput) => `
     width: ${width || '320px'};
     height: ${height || '48px'};
    `}
  &:hover {
    ${({ theme, error }: IDefaultInput) => `
     border: 2px solid ${
       error ? theme.colors.support.orange[100] : theme.colors.neutral.primary[20]
     };
    `}
  }
  &:focus {
    box-shadow: none;
    ${({ theme, error }: IDefaultInput) => `
     border: 2px solid ${
       error ? theme.colors.support.orange[100] : theme.colors.neutral.primary[20]
     };
    `}
  }
`;

export const InfoIconCont = styled(InfoStaticIconCont)`
  left: 0;
`;

export const InfoStaticMessage = styled(CaptionRegularM)`
  position: relative;
  top: -2px;
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.neutral.primary[60]};
      margin-left: ${theme.layout.spacing.nano};
  `}
`;

export const ErrorMsgCont = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 3px;
  text-transform: none;
  svg {
    margin: 0px 4px 0 0;
  }
`;

export const ErrorMessage = styled(CaptionRegularM)`
  ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.support.orange[100]};
      margin-left: 20px;
  `}
`;

export const ErrorMsgIcon = styled(ErrorIcon)`
  position: absolute;
`;

export const ArrowSearchCont = styled(ArrowCont)`
  top: 13px;
  right: 18px;
`;
